export const DYNAMIC_ATTRIBUTE_TYPES = [
  { key: 'FLOAT', label: 'Decimal' },
  { key: 'INTEGER', label: 'Inteiro' },
  { key: 'OPTIONS', label: 'Opções' },
  { key: 'TEXT', label: 'Texto' },
  { key: 'BOOLEAN', label: 'Booleano' },
]

export const DYNAMIC_ATTRIBUTE_ORIGINS = [
  { key: 'IMPORTED', label: 'Importado' },
  { key: 'USER_EXTRA_DATA', label: 'Cadastro via canais Mercafacil' },
]

export const DYNAMIC_ATTRIBUTES_TYPES_TO_COMPONENTS = {
  FLOAT: 'FormText',
  INTEGER: 'FormText',
  OPTIONS: 'FormSelect',
  TEXT: 'FormText',
  BOOLEAN: 'FormCheckbox',
}

export const isDynamicAttributeEditable = (dynamicAttribute) => {
  return dynamicAttribute?.origin === 'USER_EXTRA_DATA'
}
